import { Portal } from './portal.enum';

export enum Country {
    Austria = 'Austria',
    Belgium = 'Belgium',
    France = 'France',
    Germany = 'Germany',
}

export const COUNTRY_FROM_PORTAL_MAP: Record<Portal, Country> = {
    BellesDemeures: Country.France,
    ImmoWeb: Country.Belgium,
    ImmoWelt: Country.Germany,
    ImmoWeltAu: Country.Austria,
    Immonet: Country.Germany,
    LaCoteImmo: Country.France,
    LogicImmo: Country.France,
    LogicImmoConstruire: Country.France,
    LogicImmoNeuf: Country.France,
    LuxeResidence: Country.France,
    MeilleursAgents: Country.France,
    SeLoger: Country.France,
    SeLogerBureauxCommerces: Country.France,
    SeLogerConstruire: Country.France,
    SeLogerNeuf: Country.France,
};
